import { render, staticRenderFns } from "./KtbFastPaySuccess.vue?vue&type=template&id=2bcb7f8c&scoped=true"
import script from "./KtbFastPaySuccess.vue?vue&type=script&lang=js"
export * from "./KtbFastPaySuccess.vue?vue&type=script&lang=js"
import style0 from "./KtbFastPaySuccess.vue?vue&type=style&index=0&id=2bcb7f8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcb7f8c",
  null
  
)

export default component.exports